import { useI18n } from "../i18n";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { buildPrediction } from "../lib/words";
import { useTimer, useStations } from "./useSessionClock";
import { useSessionArchive } from "./useSessionArchive";

const defaultMinutes = (u) => {
  if (u?.is_plus) return 60;
  if (u?.trial?.active && !u?.subscription?.active) return 15;
  return 30;
};

const toPayload = (log, elapsed, prediction) => {
  const words = log.filter((e) => e.type !== "q");
  return {
    name: "Sessione", duration: elapsed, prediction,
    words: words.map(({ word, freq, time, question }) => ({ word, freq, time, question })),
    questions: log.filter((e) => e.type === "q").map((e) => e.text),
  };
};

const noCreditKey = (u) => {
  if (u?.subscription?.active) return "errMonth";
  if (u?.trial?.active) return "errToday";
  return "errTrial";
};

const requestStart = async (navigate, t, user) => {
  try {
    return (await api.post("/sessions/start")).data;
  } catch (e) {
    if (e.response?.status === 402) { toast.error(t(noCreditKey(user))); navigate("/"); }
    else toast.error(t("startFail"));
    return null;
  }
};

export const useSessionControl = ({ user, refresh, audio }) => {
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [prediction, setPrediction] = useState("");
  const [tab, setTab] = useState("log");
  const [starting, setStarting] = useState(false);
  const [maxSeconds, setMaxSeconds] = useState(defaultMinutes(user) * 60);
  const stations = useStations();
  const archive = useSessionArchive();

  const stop = async () => {
    audio.stopAudio();
    const p = buildPrediction(audio.log.filter((e) => e.type !== "q"), lang);
    setPrediction(p);
    setTab("prediction");
    await archive.save(toPayload(audio.log, elapsed, p));
  };

  const [elapsed, setElapsed] = useTimer(audio.active, maxSeconds, () => {
    toast(t("timeUp", { n: maxSeconds / 60 }));
    stop();
  });

  const start = async () => {
    if (starting) return;
    setStarting(true);
    const data = await requestStart(navigate, t, user);
    setStarting(false);
    if (!data) return;
    refresh();
    setMaxSeconds(data.max_minutes * 60);
    if (!audio.startAudio(stations, t("invocation"))) toast.error(t("noAudio"));
    setElapsed(0);
    setPrediction("");
    setTab("log");
  };

  return { start, stop, elapsed, maxSeconds, prediction, tab, setTab, stations, archive, navigate };
};
